// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from 'styled-components';
import { token } from '@atlaskit/tokens';
import { type Theme } from '../ui/theme/types';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-styled-tagged-template-expression -- Ignored via go/DSP-18766
export const ProjectPagesContentWrapper = styled.div<{ theme?: Theme }>`
	height: 100%;
	${({ theme }: { theme?: Theme }) =>
		theme?.overrideStyles?.contentWrapper
			? `padding: ${theme?.overrideStyles.contentWrapper.padding}`
			: `padding: 0`};
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-styled-tagged-template-expression -- Ignored via go/DSP-18766
export const ViewContainer = styled.div<{ theme?: Theme }>`
	width: 100%;
	${({ theme }: { theme?: Theme }) =>
		theme?.overrideStyles?.viewContainer
			? `padding: ${theme?.overrideStyles.viewContainer.padding}`
			: `padding-bottom: ${token('space.300', '24px')}`};
	display: flex;
	flex-direction: row;
	height: 100%;
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-styled-tagged-template-expression -- Ignored via go/DSP-18766
export const ViewSpacer = styled.div<{ hasHeader: boolean; isVisualRefreshEnabled?: boolean }>`
	flex: 1 1 auto;
	overflow-x: auto;
	margin-right: ${token('space.500', '40px')};
	position: relative;
	display: flex;
	flex-direction: column;
	${({ hasHeader }) => !hasHeader && `padding-top: ${token('space.300', '24px')};`}
	${({ isVisualRefreshEnabled }) => isVisualRefreshEnabled && `padding-top: ${token('space.250')};`}
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-styled-tagged-template-expression -- Ignored via go/DSP-18766
export const MainContainer = styled.div<{ theme?: Theme }>`
	${({ theme }) =>
		theme.overrideStyles?.mainContainer &&
		`background-color: ${theme.overrideStyles.mainContainer.backgroundColor};
  color: ${theme.overrideStyles.mainContainer.color};
  border-radius: ${theme.overrideStyles.mainContainer.borderRadius};
  padding: ${theme.overrideStyles.mainContainer.padding};`}
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-styled-tagged-template-expression -- Ignored via go/DSP-18766
export const PageTitleStyleWrapper = styled.div<{ theme?: Theme }>`
	${({ theme }) =>
		theme.overrideStyles?.pageTitleStyleWrapper &&
		`color: ${theme.overrideStyles.pageTitleStyleWrapper.color};
  margin-top: ${theme.overrideStyles.pageTitleStyleWrapper.marginTop}px;
  line-height: ${theme.overrideStyles.pageTitleStyleWrapper.lineHeight};
  outline: ${theme.overrideStyles.pageTitleStyleWrapper.outline};
  font-size: ${theme.overrideStyles.pageTitleStyleWrapper.fontSize};`}
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-styled-tagged-template-expression -- Ignored via go/DSP-18766
export const PageHeaderStyleWrapper = styled.div<{ theme?: Theme; isCompactHeader?: boolean }>`
	${({ theme, isCompactHeader }) =>
		theme.overrideStyles?.pageHeader?.wrapper &&
		`background-color: ${theme.overrideStyles.pageHeader.wrapper.backgroundColor};
  padding: ${theme.overrideStyles.pageHeader.wrapper.padding};
  margin: ${isCompactHeader ? `0 0 ${token('space.150', '12px')} 0` : theme.overrideStyles.pageHeader.wrapper.margin};
  border-radius: ${theme.overrideStyles.pageHeader.wrapper.borderRadius};`}
`;
